import { Add, ArrowForward, UploadFile, ViewColumn } from '@mui/icons-material';
import { LoadingButton, TabContext, TabList, TabPanel } from '@mui/lab';
import { Alert, Avatar, CircularProgress, Stack, Tab, Tooltip, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { setTransportSelectedItem } from 'app/actions/map';
import { addTransportColumnCheckedItem, deleteTransportColumnCheckedItem, setInspectionSelectedItem, setSearchValue, setSelectedItem, } from 'app/actions/transport';
import { ColumnViewMenu, FilterButton, IconButton, InputSearch, Protect, Scrollbar } from 'app/components';
import { TransportRoundedIcon } from 'app/icons';
import { TransportDialog, TransportBulkImportDialog, TransportForm, TransportInspectionDialog, TransportInspectionList, TransportList, TransportMenu, TransportTrackForm, } from 'app/pages/Transport';
import { checkedItemsSelector, inspectionSelectedItemSelector, itemsSelector, searchValueSelector, selectedItemSelector, sortSelectedItemSelector, transportColumnCheckedItemsSelector, transportMenuColumnsSelector, } from 'app/selectors/transport';
import { useAsyncAction, useRoles } from 'app/services';
import { transportLoad as mapTransportLoad } from 'app/store/map';
import { prefixLoadByTransport } from 'app/store/retransmission-prefix';
import { transportDataLoad, transportDelete, transportItemGroupUpdate, transportLoad, transportUpdate } from 'app/store/transport';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
const Transport = () => {
    var _a, _b, _c, _d;
    const formRef = useRef(null);
    const dispatch = useDispatch();
    const trackFormRef = useRef(null);
    const theme = useTheme();
    const items = useSelector(itemsSelector);
    const selectedItem = useSelector(selectedItemSelector);
    const checkedItems = useSelector(checkedItemsSelector);
    const searchValue = useSelector(searchValueSelector);
    const inspectionSelectedItem = useSelector(inspectionSelectedItemSelector);
    const sortSelectedItem = useSelector(sortSelectedItemSelector);
    const transportMenuColumns = useSelector(transportMenuColumnsSelector);
    const canBulkImport = useRoles([config.userRoles.SUPERADMIN, config.userRoles.ADMIN]);
    const { transportSelectedItem, transportItems } = useSelector((state) => state.map);
    const [tab, setTab] = useState('info');
    const { asyncAction: fetchData, isLoading: isFetchLoading } = useAsyncAction(transportLoad);
    const { asyncAction: fetchDetailData, isLoading: isFetchDetailLoading } = useAsyncAction(transportDataLoad);
    const [dialogInspectionOpen, setDialogInspectionOpen] = useState(false);
    const { asyncAction: updateGroupSubmit } = useAsyncAction(transportItemGroupUpdate);
    const { asyncAction: updateSubmit, isLoading: isUpdateLoading, isSuccessful: isUpdateSuccessful, isError: isUpdateError, } = useAsyncAction(transportUpdate, [selectedItem]);
    const { asyncAction: deleteSubmit } = useAsyncAction(transportDelete, [selectedItem]);
    const { asyncAction: fetchMapTransportData, isSuccessful: isFetchMapTransportSuccessful } = useAsyncAction(mapTransportLoad);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [bulkImportDialogOpen, setBulkImportDialogOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorTransportColumnEl, setAnchorTransportColumnEl] = useState(null);
    const handleDialogOpen = () => {
        setDialogOpen(true);
    };
    const handleDialogClose = () => {
        setDialogOpen(false);
    };
    const handleBulkImportDialogOpen = () => {
        setBulkImportDialogOpen(true);
    };
    const handleBulkImportDialogClose = () => {
        setBulkImportDialogOpen(false);
    };
    const handleTabChange = (event, value) => {
        setTab(value);
    };
    const handleFormClick = () => {
        var _a;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.handleFormSubmit();
    };
    const handleFormSubmit = (params) => {
        updateSubmit(selectedItem.id, params);
    };
    const handleSearchChange = (value) => dispatch(setSearchValue(value));
    const getSearchPlaceholder = (sortColumn) => {
        switch (sortColumn) {
            case 'name':
                return 'Поиск по названию';
            case 'group_name':
                return 'Поиск по группе';
            case 'number':
                return 'Поиск по госномеру';
            case 'vin':
                return 'Поиск по VIN';
            case 'imei':
                return 'Поиск по IMEI';
            case 'volume':
                return 'Поиск по объему бака';
            case 'comment':
                return 'Поиск по примечанию';
            default:
                return 'Поиск по названию';
        }
    };
    const handleGroupOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleGroupClose = () => {
        setAnchorEl(null);
    };
    const handleGroupChange = (id) => {
        if (checkedItems.length) {
            updateGroupSubmit({ ids: checkedItems.join(','), group_id: id });
        }
        setAnchorEl(null);
    };
    const handleTrackFormClick = () => {
        var _a;
        (_a = trackFormRef.current) === null || _a === void 0 ? void 0 : _a.handleFormSubmit();
    };
    const handleTrackFormSubmit = (params) => {
        return params;
    };
    const handleDialogInspectionClose = () => {
        setDialogInspectionOpen(false);
    };
    const handleTransportColumnOpen = (event) => {
        setAnchorTransportColumnEl(event.currentTarget);
    };
    const handleTransportColumnClose = () => {
        setAnchorTransportColumnEl(null);
    };
    const transportColumns = transportMenuColumns.map((column) => (Object.assign(Object.assign({}, column), { permissions: column.permissions || ['read', 'readonly'] })));
    useEffect(() => {
        if (!dialogInspectionOpen) {
            setTimeout(() => dispatch(setInspectionSelectedItem(null)), theme.transitions.duration.shorter);
        }
    }, [dialogInspectionOpen]);
    useEffect(() => {
        if (inspectionSelectedItem) {
            setDialogInspectionOpen(true);
        }
    }, [inspectionSelectedItem]);
    useEffect(() => {
        if (!!selectedItem && !isFetchDetailLoading) {
            fetchDetailData(selectedItem.id);
        }
    }, [selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id]);
    useEffect(() => {
        if (isUpdateSuccessful) {
            fetchMapTransportData();
        }
    }, [isUpdateSuccessful]);
    useEffect(() => {
        if (isFetchMapTransportSuccessful && transportSelectedItem) {
            const updatedTransportItem = transportItems.find((item) => item.id === transportSelectedItem.id);
            if (updatedTransportItem) {
                dispatch(setTransportSelectedItem(updatedTransportItem));
            }
        }
    }, [isFetchMapTransportSuccessful, transportItems]);
    useEffect(() => {
        fetchData();
        return () => {
            dispatch(setSelectedItem(null));
        };
    }, []);
    useEffect(() => {
        var _a;
        dispatch(prefixLoadByTransport((_a = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) !== null && _a !== void 0 ? _a : null));
    }, [dispatch, selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id, selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.group_id]);
    const { transportPrefixes, transportPrefixesTransportId, transportPrefixesGroupId } = useSelector((state) => state.retransmissionPrefix || {});
    const selectedItemPrefixes = (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) && transportPrefixesTransportId === selectedItem.id && transportPrefixesGroupId === selectedItem.group_id
        ? transportPrefixes || []
        : [];
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                width: '500px',
                height: '100%',
                position: 'relative',
                zIndex: '1010',
                overflow: 'hidden',
                bgcolor: 'background.paper',
                borderRight: '1px solid',
                borderColor: theme.palette.divider,
            }) },
            !isFetchLoading && items.length !== 0 && (React.createElement(React.Fragment, null,
                React.createElement(Stack, { direction: 'row', alignItems: 'center', sx: (theme) => ({
                        padding: theme.spacing(2),
                        '.Transport-columnButton': {
                            marginLeft: theme.spacing(1),
                        },
                        '.MuiButton-root.Mui-disabled': {
                            backgroundColor: 'background.default',
                            'svg path': {
                                fill: theme.palette.text.disabled,
                            },
                        },
                    }) },
                    React.createElement(InputSearch, { placeholder: getSearchPlaceholder(sortSelectedItem.name), value: searchValue, onChange: handleSearchChange }),
                    React.createElement(Tooltip, { title: '\u041A\u043E\u043B\u043E\u043D\u043A\u0438', arrow: true, placement: 'top' },
                        React.createElement("span", null,
                            React.createElement(FilterButton, { className: 'Transport-columnButton', active: !!anchorTransportColumnEl, onClick: handleTransportColumnOpen, endIcon: React.createElement(ViewColumn, { fontSize: 'small' }) }))),
                    React.createElement(ColumnViewMenu, { anchorEl: anchorTransportColumnEl, open: !!anchorTransportColumnEl, onClose: handleTransportColumnClose, columns: transportColumns, checkedItemsSelector: transportColumnCheckedItemsSelector, addItemAction: addTransportColumnCheckedItem, deleteItemAction: deleteTransportColumnCheckedItem, storageKey: 'transportPageColumnCheckedItems', skipFirstColumn: true }),
                    React.createElement(Protect, { permissions: ['create', 'delete', 'update'], renderPermitted: () => (React.createElement(React.Fragment, null,
                            React.createElement(Tooltip, { title: '\u041F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u0432 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0443\u044E \u0433\u0440\u0443\u043F\u043F\u0443', arrow: true, placement: 'top' },
                                React.createElement("span", null,
                                    React.createElement(IconButton, { onClick: handleGroupOpen, endIcon: React.createElement(ArrowForward, null), disabled: !checkedItems.length }))),
                            canBulkImport && (React.createElement(Tooltip, { title: '\u041F\u0430\u043A\u0435\u0442\u043D\u043E\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0422\u0421', arrow: true, placement: 'top' },
                                React.createElement("span", null,
                                    React.createElement(IconButton, { onClick: handleBulkImportDialogOpen, endIcon: React.createElement(UploadFile, { fontSize: 'small' }) })))),
                            React.createElement(Tooltip, { title: '\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0422\u0421', arrow: true, placement: 'top' },
                                React.createElement("span", null,
                                    React.createElement(IconButton, { onClick: handleDialogOpen, endIcon: React.createElement(Add, null) }))),
                            React.createElement(TransportMenu, { anchorEl: anchorEl, open: !!anchorEl, onClose: handleGroupClose, onChange: handleGroupChange }),
                            React.createElement(TransportDialog, { open: dialogOpen, onClose: handleDialogClose }),
                            canBulkImport && React.createElement(TransportBulkImportDialog, { open: bulkImportDialogOpen, onClose: handleBulkImportDialogClose }))), renderForbidden: () => React.createElement(React.Fragment, null) })),
                React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                        flex: '1 1 auto',
                        overflow: 'hidden',
                        position: 'relative',
                        paddingBottom: '30px',
                    } },
                    React.createElement(TransportList, null)),
                React.createElement(Stack, { direction: 'row', alignItems: 'center', sx: (theme) => ({
                        width: '100%',
                        position: 'absolute',
                        bottom: '0',
                        height: '30px',
                        bgcolor: 'background.paper',
                        borderTop: '1px solid',
                        borderColor: theme.palette.divider,
                    }) },
                    React.createElement(Stack, { direction: 'row', sx: {
                            marginLeft: '12px',
                            whiteSpace: 'nowrap',
                            'span:nth-of-type(2)': {
                                paddingLeft: '4px',
                            },
                        } },
                        React.createElement(Typography, { component: 'span' }, "\u0412\u044B\u0434\u0435\u043B\u0435\u043D\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430"),
                        React.createElement(Typography, { component: 'span' },
                            checkedItems.length,
                            " \u0438\u0437 ",
                            items.length))))),
            !isFetchLoading && items.length === 0 && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                    width: '100%',
                    height: '100%',
                } },
                React.createElement(Typography, { align: 'center', variant: 'body1', component: 'div' }, "\u0417\u0434\u0435\u0441\u044C \u043F\u043E\u043A\u0430 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435\u0442"),
                React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'div' }, "\u0412 \u044D\u0442\u043E\u043C \u0441\u043F\u0438\u0441\u043A\u0435 \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442"))),
            isFetchLoading && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                    width: '100%',
                    height: '100%',
                } },
                React.createElement(CircularProgress, { size: 24 })))),
        React.createElement(Stack, { direction: 'column', sx: {
                height: '100%',
                flex: '1 1 auto',
                '.simplebar-content': {
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                },
            } },
            selectedItem && (React.createElement(Scrollbar, null,
                React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                        maxWidth: '540px',
                        margin: 'auto',
                        width: '100%',
                        height: tab === 'inspection' ? '100%' : 'auto',
                        padding: theme.spacing(2),
                    }) },
                    React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                            marginBottom: theme.spacing(3),
                            '.MuiAvatar-root': {
                                width: '56px',
                                height: '56px',
                                bgcolor: theme.palette.primary.main,
                            },
                            '.MuiAvatar-circular': {
                                color: theme.palette.primary.main,
                                bgcolor: alpha(theme.palette.primary.main, 0.12),
                                svg: {
                                    width: '30px',
                                    height: '30px',
                                },
                                path: {
                                    fill: theme.palette.primary.main,
                                },
                            },
                            '.MuiTypography-root:first-of-type': {
                                marginTop: theme.spacing(1),
                            },
                        }) },
                        React.createElement(Avatar, null,
                            React.createElement(TransportRoundedIcon, { fontSize: 'large' })),
                        React.createElement(Typography, { variant: 'body1' }, selectedItem.name)),
                    React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                            width: '100%',
                            height: tab === 'inspection' ? '100%' : 'auto',
                            position: 'relative',
                            border: '1px solid',
                            borderRadius: theme.shape.borderRadius,
                            borderColor: theme.palette.divider,
                            bgcolor: 'background.paper',
                            '.MuiTabPanel-root': {
                                width: '100%',
                                padding: theme.spacing(2),
                            },
                        }) },
                        React.createElement(TabContext, { value: tab },
                            React.createElement(TabList, { onChange: handleTabChange, TabIndicatorProps: {
                                    children: React.createElement("span", null),
                                }, sx: (theme) => ({
                                    width: '100%',
                                    minHeight: '44px',
                                    borderBottom: '1px solid',
                                    borderColor: theme.palette.divider,
                                    '.MuiTab-root': {
                                        fontSize: '12px',
                                        minHeight: '44px',
                                        padding: theme.spacing(2),
                                        '&.Mui-selected': {
                                            color: 'inherit',
                                        },
                                    },
                                    '.MuiTabs-indicator': {
                                        display: 'flex',
                                        justifyContent: 'center',
                                        backgroundColor: 'transparent',
                                    },
                                    '.MuiTabs-indicator span': {
                                        width: 'calc(100% - ' + theme.spacing(4) + ')',
                                        bgcolor: theme.palette.primary.main,
                                        borderRadius: theme.shape.borderRadius,
                                    },
                                }) },
                                React.createElement(Tab, { value: 'info', label: '\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F', disableRipple: true }),
                                React.createElement(Tab, { value: 'parameters', label: '\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0421\u042D\u041F', disableRipple: true }),
                                React.createElement(Tab, { value: 'inspection', label: '\u041E\u0441\u043C\u043E\u0442\u0440\u044B', disableRipple: true })),
                            React.createElement(TabPanel, { value: 'info' },
                                React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: {
                                        width: '100%',
                                        position: 'relative',
                                        form: {
                                            width: '100%',
                                        },
                                    } },
                                    React.createElement(TransportForm, { ref: formRef, defaultValues: selectedItem, onSubmit: handleFormSubmit, retransmissionPrefixes: selectedItemPrefixes }),
                                    React.createElement(Stack, { direction: 'row', justifyContent: 'flex-end', sx: (theme) => ({
                                            width: '100%',
                                            '.MuiAlert-root': {
                                                width: '100%',
                                                marginTop: theme.spacing(2),
                                                borderRadius: theme.shape.borderRadius,
                                            },
                                        }) },
                                        !isUpdateLoading && isUpdateError && (React.createElement(Alert, { severity: 'error' }, "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0438 \u0434\u0430\u043D\u043D\u044B\u0445. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430 \u0438\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443.")),
                                        !isUpdateLoading && isUpdateSuccessful && React.createElement(Alert, { severity: 'success' }, "\u0414\u0430\u043D\u043D\u044B\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B.")),
                                    React.createElement(Protect, { permissions: ['create', 'update', 'delete', 'read+'], renderPermitted: () => (React.createElement(Stack, { direction: 'row', justifyContent: 'flex-end', sx: (theme) => ({
                                                width: '100%',
                                                paddingTop: theme.spacing(3),
                                            }) },
                                            React.createElement(LoadingButton, { variant: 'contained', loading: isUpdateLoading, onClick: handleFormClick, disableElevation: true }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F"))), renderForbidden: () => React.createElement(React.Fragment, null) }))),
                            React.createElement(TabPanel, { value: 'parameters' },
                                React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: {
                                        width: '100%',
                                        position: 'relative',
                                        form: {
                                            width: '100%',
                                        },
                                    } },
                                    React.createElement(TransportTrackForm, { ref: trackFormRef, onSubmit: handleTrackFormSubmit }),
                                    React.createElement(Protect, { permissions: ['create', 'update', 'delete'], renderPermitted: () => (React.createElement(Stack, { direction: 'row', justifyContent: 'flex-end', sx: (theme) => ({
                                                width: '100%',
                                                paddingTop: theme.spacing(3),
                                            }) },
                                            React.createElement(LoadingButton, { variant: 'contained', onClick: handleTrackFormClick, disableElevation: true }, "\u0421\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0444\u0430\u0439\u043B \u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C"))), renderForbidden: () => React.createElement(React.Fragment, null) }))),
                            React.createElement(TabPanel, { value: 'inspection', style: { height: '100%', padding: '0' } },
                                !isFetchDetailLoading && ((_b = (_a = selectedItem.inspections) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) !== 0 && (React.createElement(Stack, { direction: 'row', flexDirection: 'column', sx: {
                                        flex: '1 1 auto',
                                        height: '100%',
                                    } },
                                    React.createElement(TransportInspectionList, null),
                                    React.createElement(TransportInspectionDialog, { open: dialogInspectionOpen, onClose: handleDialogInspectionClose, defaultValues: inspectionSelectedItem }))),
                                !isFetchDetailLoading && ((_d = (_c = selectedItem.inspections) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) === 0 && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                                        width: '100%',
                                        height: '100%',
                                        padding: theme.spacing(2),
                                    }) },
                                    React.createElement(Typography, { align: 'center', variant: 'body1', component: 'div' }, "\u0417\u0434\u0435\u0441\u044C \u043F\u043E\u043A\u0430 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435\u0442"),
                                    React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'div' }, "\u0412 \u044D\u0442\u043E\u043C \u0441\u043F\u0438\u0441\u043A\u0435 \u0431\u0443\u0434\u0443\u0442 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F \u043E\u0441\u043C\u043E\u0442\u0440\u044B \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u043E\u0433\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430."))),
                                isFetchDetailLoading && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                                        width: '100%',
                                        height: '100%',
                                        padding: theme.spacing(2),
                                    }) },
                                    React.createElement(CircularProgress, { size: 24 }))))))))),
            !selectedItem && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                    height: '100%',
                    padding: theme.spacing(0, 2),
                    '.MuiTypography-root': {
                        borderRadius: '20px',
                        marginTop: '24px',
                        padding: theme.spacing(0.5, 2),
                        bgcolor: alpha(theme.palette.grey[500], 0.12),
                    },
                }) },
                React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'label' }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430"))))));
};
export default Transport;
